<div class="create-task">
    <!-- <div *ngIf="!isEdit" class="create-task__header" fxLayout="column" fxLayoutAlign="center flex-start"></div>  -->
    <div *ngIf="!isEdit" class="create-task__header" fxLayout="column" fxLayoutAlign="center flex-start">
        <div class="create-task__header-title">{{header}} TASK</div>
        <div class="create-task__header-subtitle">
            Enter details to assign and track efficiently.
        </div>
    </div>
    <div *ngIf="isEdit" class="create-task__header" fxLayout="column" fxLayoutAlign="center flex-start">
        <div class="create-task__header-title">
            EDIT DETAILS
        </div>
        <div class="create-task__header-subtitle">
            Make sure to save changes to keep your information updated.
        </div>
    </div>
    <form [formGroup]="addEventForm">
        <div class="create-task__main" id="add_appointment">
            <div class="width_100">
                <div class="create-task__main-section">
                    <div class="width_100" fxLayout="row" fxLayoutGap="20px">
                        <div class="width_50" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                            <mat-label>Departments</mat-label>
                            <mat-form-field class="width_100" appearance="outline">
                                <mat-select formControlName="department" name="department"
                                    (ngModelChange)="departmentChange($event)">

                                    <mat-option value="" disabled>Select</mat-option>

                                    <mat-option *ngFor="let dept of taskDepartments" [value]="dept.id">
                                        {{ (dept.text === 'Other' || dept.text === 'Others')
                                        ? 'Pending assignment'
                                        : dept.text }}
                                    </mat-option>

                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="width_50" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                            <mat-label>Responsible Person</mat-label>
                            <mat-form-field class="width_100" appearance="outline">
                                <mat-select formControlName="responsiblePerson" name="responsiblePerson"
                                    (ngModelChange)="responsiblePersonChange($event)">
                                    <mat-option value="" disabled>Select</mat-option>
                                    <mat-option *ngFor="let person of responsiblePersons" [value]="person.userId">
                                        {{ combinedDisplayName(person.firstName,person.lastName) }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="width_100" fxLayout="row" fxLayoutGap="20px">
                        <div class="width_50" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                            <mat-label>Priority</mat-label>
                            <mat-form-field class="width_100" appearance="outline"
                                [ngClass]="{ 'is-invalid': addEventForm.get('priority')?.invalid && addEventForm.get('priority')?.touched }">
                                <mat-select formControlName="priority" name="priority"
                                    (ngModelChange)="priorityChange($event)">
                                    <!-- Priority list -->
                                    <mat-option value="" disabled>Select</mat-option>
                                    <mat-option style="text-transform: capitalize;"
                                        *ngFor="let priority of priorityList" [value]="priority.id">
                                        {{ priority.text }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div *ngIf="
                  addEventForm.controls['priority'].invalid &&
                  (addEventForm.controls['priority'].dirty ||
                    addEventForm.controls['priority'].touched)
                " class="alert">
                                <mat-error *ngIf="addEventForm.get('priority').errors?.required">Priority is required
                                </mat-error>
                            </div>
                        </div>

                        <div class="width_50" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                            <mat-label>Due Date</mat-label>
                            <mat-form-field class="width_100" appearance="outline"
                                [ngClass]="{ 'is-invalid': addEventForm.get('dueDate')?.invalid && addEventForm.get('dueDate')?.touched }">
                                <mat-datepicker-toggle matPrefix [for]="dueDatePicker"></mat-datepicker-toggle>
                                <input matInput [matDatepicker]="dueDatePicker" name="dueDate" formControlName="dueDate"
                                    [min]="minDate" placeholder="Due Date">
                                <mat-datepicker #dueDatePicker></mat-datepicker>
                            </mat-form-field>
                            <div *ngIf="
                  addEventForm.controls['dueDate'].invalid &&
                  (addEventForm.controls['dueDate'].dirty ||
                    addEventForm.controls['dueDate'].touched)
                " class="alert">
                                <mat-error *ngIf="addEventForm.get('title').errors?.required">Due date is required
                                </mat-error>
                            </div>
                        </div>
                    </div>

                    <div class="width_100" fxLayout="row" fxLayoutGap="20px">
                        <div class="width_100" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                            <mat-label>Title</mat-label>
                            <mat-form-field class="width_100" appearance="outline"
                                [ngClass]="{ 'is-invalid': addEventForm.get('title')?.invalid && addEventForm.get('title')?.touched }">
                                <input type="text" name="title" matInput formControlName="title"
                                    placeholder="Enter task title" />
                            </mat-form-field>
                            <div *ngIf="
                  addEventForm.controls['title'].invalid &&
                  (addEventForm.controls['title'].dirty ||
                    addEventForm.controls['title'].touched)
                " class="alert">
                                <mat-error *ngIf="addEventForm.get('title').errors?.required">Title is required
                                </mat-error>
                            </div>
                        </div>
                    </div>
                    <div class="width_100" fxLayout="row" fxLayoutGap="20px">
                        <div class="width_100" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                            <mat-label>Description</mat-label>
                            <mat-form-field class="width_100" appearance="outline"
                                [ngClass]="{ 'is-invalid': addEventForm.get('description')?.invalid && addEventForm.get('description')?.touched }">
                                <textarea matInput class="filter_3 width_100 custom_text_area"
                                    placeholder="What needs to be done? (e.g, Check air conditioning unit for cooling failure.)"
                                    formControlName="description"></textarea>
                            </mat-form-field>
                            <div *ngIf="
                  addEventForm.controls['description'].invalid &&
                  (addEventForm.controls['description'].dirty ||
                    addEventForm.controls['description'].touched)
                " class="alert">
                                <mat-error *ngIf="addEventForm.get('description').errors?.required">Description is
                                    required
                                </mat-error>
                            </div>
                        </div>
                    </div>
                    <div class="width_100" fxLayout="row" fxLayoutGap="20px">
                        <div class="width_100" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                            <mat-label>Location Details</mat-label>
                            <mat-form-field class="width_100" appearance="outline">
                                <input type="text" name="location" matInput formControlName="location"
                                    placeholder="Enter room number or area" />
                            </mat-form-field>
                            <div
                                *ngIf="addEventForm.controls['location'].invalid && addEventForm.controls['location'].touched">
                                <mat-error *ngIf="addEventForm.get('location').errors?.required">Location is required
                                </mat-error>
                            </div>
                        </div>
                    </div>
                    <!-- Image upload code -->
                    <!-- <div class="width_100" fxLayout="row" fxLayoutGap="20px">
                        <div class="width_100" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                            <mat-label>Upload Photo</mat-label>
                            <div class="upload-container" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
                                (dragleave)="onDragLeave($event)" [class.dragover]="isDragging">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
                                    <path id="cloud-upload-outline"
                                        d="M19.35,12.04a7.492,7.492,0,0,0-14-2A6,6,0,0,0,6,22H19a4.986,4.986,0,0,0,.35-9.96M19,20H6a4,4,0,0,1-.44-7.97l1.07-.11.5-.95a5.487,5.487,0,0,1,10.26,1.46l.3,1.5,1.53.11A2.983,2.983,0,0,1,19,20M8,15h2.55v3h2.9V15H16l-4-4Z"
                                        transform="translate(0 -6)" fill="#228be6" />
                                </svg>
                                <p *ngIf="!preview">
                                    Drag & drop or
                                    <label for="fileInput" class="browse">browse</label>
                                </p>

                                <input type="file" id="fileInput" (change)="onFileSelected($event)" accept="image/*"
                                    hidden />

                                 <img *ngIf="preview" [src]="preview" class="preview" /> 

                            </div>
                            <div class="width_100 extra_border" fxLayout="row" fxLayoutAlign="start center">
                                <div class="inline_block">
                                    <div>
                                        <div class="delete-div" *ngIf="preview">
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink" width="34" height="34"
                                                    viewBox="0 0 34 34">
                                                    <defs>
                                                        <filter id="Ellipse_105" x="0" y="0" width="34" height="34"
                                                            filterUnits="userSpaceOnUse">
                                                            <feOffset dy="3" input="SourceAlpha" />
                                                            <feGaussianBlur stdDeviation="3" result="blur" />
                                                            <feFlood flood-opacity="0.161" />
                                                            <feComposite operator="in" in2="blur" />
                                                            <feComposite in="SourceGraphic" />
                                                        </filter>
                                                    </defs>
                                                    <g id="Group_5071" data-name="Group 5071"
                                                        transform="translate(11078 19975)">
                                                        <g transform="matrix(1, 0, 0, 1, -11078, -19975)"
                                                            filter="url(#Ellipse_105)">
                                                            <circle id="Ellipse_105-2" data-name="Ellipse 105" cx="8"
                                                                cy="8" r="8" transform="translate(9 6)"
                                                                fill="rgba(255,255,255,0.8)" />
                                                        </g>
                                                        <path id="close"
                                                            d="M15.5,8.306,14.694,7.5,11.5,10.694,8.306,7.5,7.5,8.306,10.694,11.5,7.5,14.694l.806.806L11.5,12.306,14.694,15.5l.806-.806L12.306,11.5Z"
                                                            transform="translate(-11072.5 -19972.5)" />
                                                    </g>
                                                </svg>
                                            </span>
                                        </div>
                                        <img class="mobile_edit_banner image-gap" *ngIf="preview" [src]="preview">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- Multi image uplaod -->
                    <div class="width_100" fxLayout="row" fxLayoutGap="20px">
                        <div class="width_100" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                            <mat-label>Upload Photos</mat-label>

                            <div class="upload-container" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
                                (click)="triggerFileInput()" (dragleave)="onDragLeave($event)"
                                [class.dragover]="isDragging">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
                                    <path id="cloud-upload-outline"
                                        d="M19.35,12.04a7.492,7.492,0,0,0-14-2A6,6,0,0,0,6,22H19a4.986,4.986,0,0,0,.35-9.96M19,20H6a4,4,0,0,1-.44-7.97l1.07-.11.5-.95a5.487,5.487,0,0,1,10.26,1.46l.3,1.5,1.53.11A2.983,2.983,0,0,1,19,20M8,15h2.55v3h2.9V15H16l-4-4Z"
                                        transform="translate(0 -6)" fill="#228be6" />
                                </svg>

                                <p>
                                    Drag & drop or
                                    <label for="fileInput" class="browse" (click)="onBrowseClick($event)">browse</label>
                                </p>

                                <!-- multiple file selection -->
                                <input #fileInput type="file" id="fileInput" (change)="onFilesSelected($event)"
                                    accept="image/*" multiple hidden />
                            </div>

                            <!-- Preview multiple images -->
                            <div class="width_100 extra_border" fxLayout="row" fxLayoutAlign="start center">
                                <div class="inline_block" *ngFor="let preview of previews; let i = index">
                                    <div class="delete-div" (click)="removeImage(i)">
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" width="34" height="34"
                                                viewBox="0 0 34 34">
                                                <defs>
                                                    <filter id="Ellipse_105" x="0" y="0" width="34" height="34"
                                                        filterUnits="userSpaceOnUse">
                                                        <feOffset dy="3" input="SourceAlpha" />
                                                        <feGaussianBlur stdDeviation="3" result="blur" />
                                                        <feFlood flood-opacity="0.161" />
                                                        <feComposite operator="in" in2="blur" />
                                                        <feComposite in="SourceGraphic" />
                                                    </filter>
                                                </defs>
                                                <g id="Group_5071" data-name="Group 5071"
                                                    transform="translate(11078 19975)">
                                                    <g transform="matrix(1, 0, 0, 1, -11078, -19975)"
                                                        filter="url(#Ellipse_105)">
                                                        <circle id="Ellipse_105-2" data-name="Ellipse 105" cx="8" cy="8"
                                                            r="8" transform="translate(9 6)"
                                                            fill="rgba(255,255,255,0.8)" />
                                                    </g>
                                                    <path id="close"
                                                        d="M15.5,8.306,14.694,7.5,11.5,10.694,8.306,7.5,7.5,8.306,10.694,11.5,7.5,14.694l.806.806L11.5,12.306,14.694,15.5l.806-.806L12.306,11.5Z"
                                                        transform="translate(-11072.5 -19972.5)" />
                                                </g>
                                            </svg>
                                        </span>
                                    </div>
                                    <img class="mobile_edit_banner image-gap" [src]="preview">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="width_100" fxLayout="column" fxLayoutGap="20px">
                        <mat-checkbox (change)="onEscalateChange($event)" formControlName="isEscalate">
                            <span class="orange">Escalate </span>
                            <span class="normal">
                                (Escalate issue for prompt resolution and alert management to urgent concerns)
                            </span>
                        </mat-checkbox>
                        <div *ngIf="isEscalate" class="width_100" fxLayout="column" fxLayoutGap="10px">
                            <div class="width_100" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                                <mat-label>Reason for Escalation</mat-label>
                                <mat-form-field class="width_100" appearance="outline"
                                    [ngClass]="{ 'is-invalid': addEventForm.get('escalationReason')?.invalid && addEventForm.get('escalationReason')?.touched }">
                                    <mat-select formControlName="escalationReason" name="department"
                                        (selectionChange)="escalationReasonChange($event)">
                                        <mat-option value="" disabled>Select</mat-option>
                                        <mat-option *ngFor="let reason of escalationReasonList" [value]="reason">
                                            {{ reason }}
                                        </mat-option>

                                    </mat-select>
                                </mat-form-field>
                                <div
                                    *ngIf="addEventForm.controls['escalationReason'].invalid && addEventForm.controls['escalationReason'].touched">
                                    <mat-error *ngIf="addEventForm.get('escalationReason').errors?.required">Please
                                        select reason for escalation
                                    </mat-error>
                                </div>
                            </div>
                            <div class="width_100" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
                                <mat-label>Additional Note/Remarks</mat-label>
                                <mat-form-field class="width_100" appearance="outline">
                                    <textarea matInput placeholder="Write your note/remarks here"
                                        formControlName="remarks"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="create-task__summary" fxLayout="row" fxLayoutAlign="end end">
            <div class="create-task__summary-actions" fxLayoutAlign="end center">
                <div mat-ripple class="create-task__summary-clear cursor_pointer" (click)="onCancel()">
                    Cancel
                </div>
                <div mat-ripple class="create-task__summary-show cursor_pointer" (click)="onSubmit()" type="submit">
                    Save
                </div>
            </div>
        </div>
    </form>
</div>